<template>
    <div>
        <b-card class="mt-2 mb-0 smallinputs" header-tag="header" footer-tag="footer" border-variant="success">

            <b-card-body class="mt-2 py-0 px-0 ">
                <b-tabs class="gridtabs" v-model="tabindex">

                    <b-tab active>
                        <template #title>
                            <i class="fa fa-handshake-o text-primary mr-2"></i><span class="strong">{{ value.slac }} |
                                {{ value.slacname
                                }} | {{ value.eventcode }} | {{ value.eventname }}</span>
                        </template>

                        <p class="pb-0 mb-1 pt-3 px-0 vertical-top">
                            <b-row>
                                <b-col>
                                    <div class="mt-0 mb-1 text-center">
                                        <table class="w-100pct">
                                            <tr class="header-dark mb-1">
                                                <td role="columnheader" scope="col" aria-colindex="1"
                                                    class="table-b-table-default text-center w-25px">
                                                    <input style="height: 15px; margin-top: 2px" type="checkbox"
                                                        :checked="true" :disabled="true" />
                                                </td>
                                                <!-- colspan="2" -->
                                                <td class="text-center">Group</td>
                                                <!-- <td class="" style="width:25%">SL A/C</td>
                                                <td class="" style="width:25%">Event</td> -->
                                                <td class="" style="width:50%"><span v-if="mifields.length <= 0">Your
                                                        Ref / PO</span></td>
                                                <td style="width:50%" @click="cliplines()">RefNo <i @click="cliplines()"
                                                        :id="'lines-copy_' + value.id"
                                                        class="fa fa-clipboard hover-primary" title="Copy"></i>
                                                </td>
                                                <b-tooltip :target="'lines-copy_' + value.id" placement="top">Copy
                                                    selected lines to the clipboard</b-tooltip>
                                                <td></td>
                                            </tr>
                                            <tr>
                                                <td class="w-30px pt-3px">
                                                    <b-input-group class="m-auto w-15px">
                                                        <input class="mt-5px" id="travellerCheck" style="height: 13px;"
                                                            type="checkbox" :checked="true" :value="true"
                                                            :disabled="true" />
                                                    </b-input-group>
                                                </td>
                                                <td class="w-30px pt-5px"> <span class="small text-primary">{{ 0 + 1
                                                        }}.</span></td>
                                                <!-- <td class="w-30px pt-5px"> <i
                                                        class="fa fa-handshake-o text-primary mr-2"></i>
                                                </td> -->
                                                <!-- <td class="pt-3px">
                                                    <b-form-group class="mb-3px">
                                                        <b-input-group>
                                                            <treeselect placeholder="Select slac..."
                                                                searchPromptText="Type at least 3 chars..."
                                                                v-model="value.slac" :clearable="true" :multiple="false"
                                                                :async="true" :load-options="treeselect_loadSLAC"
                                                                :show-count="true" :flatten-search-results="true"
                                                                :disable-branch-nodes="true" :matchKeys="['id']"
                                                                search-nested>
                                                                <div slot="value-label" slot-scope="{ node }">
                                                                    {{ node.raw.id }}
                                                                </div>
                                                            </treeselect>
                                                        </b-input-group>
                                                    </b-form-group>
                                                </td> -->
                                                <!-- <td class="pt-3px">
                                                    <b-form-group class="mb-3px">
                                                        <b-input-group>
                                                            <treeselect placeholder="Select event..."
                                                                searchPromptText="Type at least 4 chars..."
                                                                v-model="value.eventcode" :clearable="true"
                                                                :multiple="false" :async="true"
                                                                :load-options="treeselect_loadEvent" :show-count="true"
                                                                :flatten-search-results="true"
                                                                :disable-branch-nodes="true" :matchKeys="['id']"
                                                                search-nested @select="treeselect">
                                                                <div slot="value-label" slot-scope="{ node }">
                                                                    {{ node.raw.id }}
                                                                </div>
                                                            </treeselect>
                                                        </b-input-group>
                                                    </b-form-group>
                                                </td> -->
                                                <td class="pt-3px">
                                                    <b-form-group class="mb-3px" v-if="mifields.length <= 0">
                                                        <b-input-group>
                                                            <b-form-input size="sm" v-model="value.yourref"
                                                                placeholder="P/O" :formatter="onlyascii"
                                                                trim></b-form-input>
                                                            <b-input-group-append>
                                                                <b-button size="sm" variant="outline-secondary"
                                                                    @click="value.yourref = ''">
                                                                    <i class="fa fa-remove"></i>
                                                                </b-button>
                                                            </b-input-group-append>
                                                        </b-input-group>
                                                    </b-form-group>
                                                </td>
                                                <td>{{ value.referenceno }}</td>

                                                <td></td>
                                            </tr>

                                        </table>
                                    </div>
                                    <!-- {{ mifields }} -->

                                    <div class="my-0">

                                        <b-row align-v="start" class="" no-gutters v-if="mifields.length > 0">
                                            <b-col cols="auto" class="text-right" style="width:56px">
                                                <!-- <i class="fa fa-list text-primary"
                                                    style="margin-top:24px; margin-right:8px;"> </i> -->
                                            </b-col>
                                            <!-- <b-col v-if="mifields.length == 0"> There are no fields to display</b-col> -->
                                            <b-col class="px-2">
                                                <b-row>
                                                    <b-col cols="12" sm="6" md="4" xl="3"
                                                        v-for="(mifield, index) in mifields" :key="index">
                                                        <!-- <b-form-group :label="label(mifield)" label-cols="12" label-size="sm">-->
                                                        <b-form-group
                                                            :label="$helpers.requiredlabel(requirement, mifield.label)"
                                                            :class="$helpers
                                                                .requiredlabel(requirement, mifield.label)
                                                                .slice(0, 1) == '*'
                                                                ? 'text-danger'
                                                                : ''
                                                                " label-cols="12" label-size="sm">
                                                            <b-input-group>
                                                                <!-- :placeholder="placeholder(mifield)" :debounce="mifields.debounce" -->
                                                                <!-- v-model="mifields.args[mifield.key]"  -->
                                                                <b-form-input v-if="mifield.type == 'input'" type="text"
                                                                    :disabled="mifield.active == '0'" size="sm" trim
                                                                    v-model="mifield.value"
                                                                    :placeholder="mifield.label"></b-form-input>

                                                                <!-- v-if="mifield.clearable" @click="mifields.args[mifield.key] = null"-->
                                                                <b-input-group-append v-if="mifield.type == 'input'">
                                                                    <b-button size="sm" variant="outline-secondary"
                                                                        @click="mifield.value = ''">
                                                                        <i class="fa fa-remove"></i>
                                                                    </b-button>
                                                                </b-input-group-append>
                                                            </b-input-group>

                                                            <!-- && filter.options
                      :multiple="filter.multiple == true ? true : false" -->
                                                            <!-- v-model="mifield.args[mifield.key]" :placeholder="mifield.placeholder"-->
                                                            <treeselect v-if="mifield.type == 'listofvalues'"
                                                                :show-count="true" :flatten-search-results="true"
                                                                :clearable="mifield.required" :disable-branch-nodes="true"
                                                                :matchKeys="['id']" search-nested
                                                                :options="mifield.options" v-model="mifield.value">
                                                            </treeselect>

                                                        </b-form-group>
                                                    </b-col>
                                                </b-row>
                                            </b-col>
                                        </b-row>
                                    </div>
                                    <!-- <div class="mt-0 mb-1 text-center">
                                        <table class="w-100pct">
                                            <tr class="header-dark mb-1">
                                                <td role="columnheader" scope="col" aria-colindex="1"
                                                    class="table-b-table-default text-center w-25px">
                                                    <input style="height: 15px; margin-top: 2px" type="checkbox"
                                                        :checked="true" :disabled="true" />
                                                </td>
                                                <td colspan="2" class="text-center">Travellers</td>
                                                <td class="" style="width:33%">Traveller</td>
                                                <td class="" style="width:33%">Your Ref / PO</td>
                                                <td @click="cliplines()">RefNo <i @click="cliplines()"
                                                        :id="'lines-copy_' + value.id"
                                                        class="fa fa-clipboard hover-primary" title="Copy"></i></td>
                                                <b-tooltip :target="'lines-copy_' + value.id" placement="top">Copy
                                                    selected lines to the clipboard</b-tooltip>
                                                <td></td>
                                            </tr>
                                            <tr>
                                                <td class="w-30px">
                                                    <b-input-group class="m-auto w-15px">
                                                        <input id="travellerCheck" style="height: 13px" type="checkbox"
                                                            :checked="true" :value="true" :disabled="true" />
                                                    </b-input-group>
                                                </td>
                                                <td class="w-30px"> <span class="small text-primary">{{ 0 + 1
                                                        }}.</span></td>
                                                <td class="w-30px"> <i class="fa fa-user text-primary mr-2"></i></td>
                                                <td>
                                                    <b-form-group class="mb-3px">
                                                        <b-input-group>
                                                            <b-form-input size="sm" v-model="value.lines[0].passenger"
                                                                placeholder="Passenger" :formatter="onlyascii"
                                                                trim></b-form-input>
                                                            <b-input-group-append>
                                                                <b-button size="sm" variant="outline-secondary"
                                                                    @click="value.lines[0].passenger = ''">
                                                                    <i class="fa fa-remove"></i>
                                                                </b-button>
                                                            </b-input-group-append>
                                                        </b-input-group>
                                                    </b-form-group>
                                                </td>
                                                <td>
                                                    <b-form-group class="mb-3px">
                                                        <b-input-group>
                                                            <b-form-input size="sm" v-model="value.yourref"
                                                                placeholder="P/O" :formatter="onlyascii"
                                                                trim></b-form-input>
                                                            <b-input-group-append>
                                                                <b-button size="sm" variant="outline-secondary"
                                                                    @click="value.yourref = ''">
                                                                    <i class="fa fa-remove"></i>
                                                                </b-button>
                                                            </b-input-group-append>
                                                        </b-input-group>
                                                    </b-form-group>
                                                </td>
                                                <td>{{ value.referenceno }}</td>
                                                <td></td>
                                            </tr>

                                        </table>
                                    </div> -->

                                    <div class="mt-2 mb-1 text-center">
                                        <table class="w-100pct">
                                            <tr class="header-dark ">
                                                <td role="columnheader" scope="col" aria-colindex="1"
                                                    class="table-b-table-default text-center w-25px">

                                                    <input id="linesAll" style="height: 15px; margin-top: 2px"
                                                        type="checkbox" :checked="allLinesChecked" @change="linesAll"
                                                        :disabled="value.lines.length == 1 || value.lines.filter(o => o.sale != 'N/A').length == 1" />
                                                </td>
                                                <td colspan="3" class="text-center">Lines </td>
                                                <td>SupType</td>
                                                <td> DateTravel</td>
                                                <td> Event </td>
                                                <td> SL A/C </td>
                                                <td> Agent </td>
                                                <!-- <td> RefNo </td> -->
                                                <!-- <td> Traveller </td> -->
                                                <td> Details </td>
                                                <!-- <td> CUR </td> -->
                                                <!-- <td> VAT Rate </td>
                                                <td> PayBy </td> -->
                                                <td> BL A/C </td>
                                                <td> Cost GBP </td>
                                                <td> Margin</td>
                                                <td> Sale GBP </td>
                                                <td> VAT GBP </td>
                                                <td> Amount GBP</td>
                                            </tr>
                                            <tr>
                                                <td></td>
                                                <td colspan="3"></td>
                                                <td> </td>
                                                <td> </td>
                                                <!-- <td> </td> -->
                                                <!-- <td> </td> -->
                                                <td> </td>
                                                <!-- <td> </td>
                                                <td> </td> -->
                                                <td> </td>
                                                <td> </td>
                                                <td> </td>
                                                <td> </td>
                                                <td> </td>

                                                <td> </td>
                                                <td> </td>
                                            </tr>
                                            <tr v-for="(line, index) in value.lines" :key="index">

                                                <td class="w-15px">
                                                    <b-input-group class="m-auto w-15px">
                                                        <input id="lineCheck" style="height: 12px" type="checkbox"
                                                            v-model="lines" @click="toggleLine($event, index)"
                                                            :checked="true" :value="line"
                                                            :disabled="value.lines.length == 1 || line.fare == 'N/A' || value.lines.filter(o => o.fare != 'N/A').length == 1" />

                                                    </b-input-group>
                                                </td>
                                                <td colspan="3" class="w-30px">
                                                    <span class="small text-primary">{{ index + 1 }}.</span>
                                                </td>
                                                <!-- <td class="w-30px">
                                                    <i :class="icontype(line.type)" class="mr-2" :title="line.type"></i>
                                                </td> -->
                                                <td class="w-70px p-0">
                                                    <b-row>
                                                        <b-col>
                                                            <b-form-group class="mb-3px z-0">
                                                                <b-input-group>
                                                                    <button type="button"
                                                                        :id="'lines-type_' + line.referenceno"
                                                                        class="h-20px radius-0 pr-1 btn btn-sm btn-secondary dropdown-toggle dropdown-toggle-split"
                                                                        data-toggle="dropdown" aria-haspopup="true"
                                                                        aria-expanded="false">
                                                                        <span class="sr-only">Toggle Dropdown</span>
                                                                    </button>
                                                                    <b-button class="h-22px w-45px text-center"
                                                                        :id="'lines-faicon_' + line.referenceno"
                                                                        size="sm" variant="outline-secondary"
                                                                        @click="setType(index)" :disabled="false">
                                                                        <span
                                                                            class="border-right-light">{{suppliertype_options.find(o => o.id == line.type).id }} </span>
                                                                        <i :class="line.type ? 'fa ' + suppliertype_options.find(o => o.id == line.type).faicon : 'fa fa-exclamation-triangle text-danger'"
                                                                            class="font-14px w-20px pl-1"></i>
                                                                    </b-button>
                                                                    <b-tooltip
                                                                        :target="'lines-faicon_' + line.referenceno"
                                                                        placement="top">
                                                                        {{suppliertype_options.find(o => o.id ==
                                                                            line.type).label
                                                                        }}</b-tooltip>
                                                                    <b-popover
                                                                        :target="'lines-type_' + line.referenceno"
                                                                        title="Select Supplier Type" triggers="focus"
                                                                        :placement="'lefttop'" custom-class="p-0">
                                                                        <p v-for="(faicon, aindex) in suppliertype_options"
                                                                            :key="aindex"
                                                                            class="text-left hover-pointer hover-highlight px-2 py-1 mb-0">
                                                                            <span @click="setType(index, faicon.id)">
                                                                                <i class="w-20px"
                                                                                    :class="'fa ' + faicon.faicon"></i>{{
                                                                                        faicon.label
                                                                                    }}</span>
                                                                        </p>
                                                                    </b-popover>
                                                                </b-input-group>
                                                            </b-form-group>
                                                        </b-col>
                                                    </b-row>
                                                </td>

                                                <td class="w-110px text-left">
                                                    <b-form-group class="mb-3px h-22px">
                                                        <b-input-group>
                                                            <daterangepicker class="w-auto" size="sm" ref="date_at"
                                                                v-model="line.start_at_pick" :opens="'right'"
                                                                :locale-data="locale_data" :ranges="false"
                                                                :showDropdowns="true" :single-date-picker="'true'"
                                                                @update="pick_date($event, 'start_at', line)">
                                                            </daterangepicker>
                                                            <b-input-group-append>
                                                                <b-button size="sm" variant="outline-secondary" @click="line.start_at_pick = {
                                                                    startDate: null,
                                                                    endDate: null,
                                                                }
                                                                    ">
                                                                    <i class="fa fa-remove"></i>
                                                                </b-button>
                                                            </b-input-group-append>
                                                        </b-input-group>
                                                    </b-form-group>
                                                </td>
                                                <td class="w-160px">
                                                    <b-form-group class="mb-3px">
                                                        <b-input-group>
                                                            <treeselect class="h-21px" placeholder="Select event..."
                                                                searchPromptText="Type at least 4 chars..."
                                                                v-model="line.eventcode" :clearable="true"
                                                                :multiple="false" :async="true"
                                                                :load-options="treeselect_loadEvent" :show-count="true"
                                                                :flatten-search-results="true"
                                                                :disable-branch-nodes="true" :matchKeys="['id']"
                                                                search-nested @select="edited = true">
                                                                <div slot="value-label" slot-scope="{ node }">
                                                                    {{ node.raw.id }}
                                                                </div>
                                                            </treeselect>
                                                        </b-input-group>
                                                    </b-form-group>
                                                </td>
                                                <td class="w-120px">
                                                    <b-form-group class="mb-3px">
                                                        <b-input-group>
                                                            <treeselect class="h-21px" placeholder="Select slac..."
                                                                searchPromptText="Type at least 3 chars..."
                                                                v-model="line.slac" :clearable="true" :multiple="false"
                                                                :async="true" :load-options="treeselect_loadSLAC"
                                                                :show-count="true" :flatten-search-results="true"
                                                                :disable-branch-nodes="true" :matchKeys="['id']"
                                                                search-nested @select="edited = true">
                                                                <div slot="value-label" slot-scope="{ node }">
                                                                    {{ node.raw.id }}
                                                                </div>
                                                            </treeselect>
                                                        </b-input-group>
                                                    </b-form-group>
                                                </td>
                                                <!-- <td>
                                                    <div class="text-center form-control form-control-sm disabled">
                                                        {{ line.agent }}</div>
                                                </td> -->
                                                <td class="w-70px">
                                                    <b-row>
                                                        <b-col>
                                                            <b-form-group class="mb-3px">
                                                                <b-input-group>
                                                                    <b-dropdown :id="'lines-agent_' + line.referenceno"
                                                                        split split-variant="outline-secondary"
                                                                        variant="secondary"
                                                                        :text="line.agent ? line.agent : '***'"
                                                                        size="sm" class="h-22px dropdown-input agent-dropdown z-0"
                                                                        right>
                                                                        <b-dropdown-item
                                                                            v-for="(agent, aindex) in options_agent"
                                                                            :key="aindex" href="#"
                                                                            :active="line.agent == agent.id ? true : false"
                                                                            @click="claimLine(index, agent.id)">{{
                                                                                agent.label
                                                                            }}</b-dropdown-item>
                                                                    </b-dropdown>
                                                                    <b-input-group-append>
                                                                        <b-button
                                                                            :id="'lines-owner_' + line.referenceno"
                                                                            size="sm" variant="outline-secondary"
                                                                            @click="claimLine(index)" :disabled="false">
                                                                            <i :class="line.claimed ? 'fa fa-user text-primary font-14px' : 'fa fa-user text-danger font-14px'"
                                                                                class="padding-left:5px !important; margin-top:15px"></i>
                                                                        </b-button>
                                                                        <b-tooltip v-if="line.claimed"
                                                                            :target="'lines-owner_' + line.referenceno"
                                                                            placement="top">Click
                                                                            to
                                                                            unclaim, agent {{ line.agent }}</b-tooltip>
                                                                        <b-tooltip v-if="!line.claimed"
                                                                            :target="'lines-owner_' + line.referenceno"
                                                                            placement="top">Click
                                                                            to claim as {{ user.initials }}</b-tooltip>
                                                                    </b-input-group-append>
                                                                    <b-tooltip
                                                                        :target="'lines-agent_' + line.referenceno"
                                                                        placement="top">{{
                                                                            line.agentname ? line.agentname : '*BLOCKED*'
                                                                        }}</b-tooltip>
                                                                </b-input-group>
                                                            </b-form-group>
                                                        </b-col>
                                                    </b-row>

                                                    <!-- <b-form-group class="mb-3px">
                                                        <b-input-group>
                                                            <b-form-input :id="'lines-agent_' + line.referenceno"
                                                                size="sm" v-model="line.agent" placeholder=""
                                                                class="text-center" :disabled="false"></b-form-input>
                                                            <b-tooltip :target="'lines-agent_' + line.referenceno"
                                                                placement="top">{{
                                                                    line.agentname }}</b-tooltip>
                                                            <b-input-group-append>
                                                                <b-button :id="'lines-owner_' + index" size="sm"
                                                                    variant="outline-secondary"
                                                                    @click="claimLine(index)" :disabled="true">
                                                                    <i :class="line.claimed ? 'fa fa-user text-primary font-14px' : 'fa fa-user text-danger font-14px'"
                                                                        class="padding-left:5px !important; margin-top:15px"></i>
                                                                </b-button>
                                                                <b-tooltip v-if="line.claimed"
                                                                    :target="'lines-owner_' + index"
                                                                    placement="top">Click
                                                                    to
                                                                    unclaim, agent {{ line.agent }}</b-tooltip>
                                                                <b-tooltip v-if="!line.claimed"
                                                                    :target="'lines-owner_' + index"
                                                                    placement="top">Click
                                                                    to claim as {{ user.initials }}</b-tooltip>
                                                            </b-input-group-append>
                                                        </b-input-group>
                                                    </b-form-group> -->
                                                </td>
                                                <!-- <td>
                                                    <div class="text-center form-control form-control-sm disabled">
                                                        {{ line.referenceno }}</div>
                                                </td> -->
                                                <!-- <td class="w-10pct">
                                                    <b-form-group>
                                                    
                                                        <b-form-textarea
                                                            :style="'min-height:22px !important; font-size:12px; color:#549c60 !important; padding:0; padding-left:1px '"
                                                            v-model="line.passenger"></b-form-textarea>
                                                    </b-form-group>
                                                </td> -->
                                                <!-- class="min-w-250px" -->
                                                <!-- <td class="w-20pct">
                                                    <b-form-group>
                                                 
                                                        <b-form-textarea
                                                            :style="'min-height:22px !important; font-size:12px; color:#549c60 !important; padding:0; padding-left:1px '"
                                                            v-model="line.details"></b-form-textarea>
                                                    </b-form-group>
                                             
                                                </td> -->

                                                <td class="text-left">

                                                    <div @click="line.expanded = !line.expanded"
                                                        class="text-left form-control form-control-sm disabled"
                                                        :style="'cursor: pointer;'">
                                                        <i :class="line.expanded ? 'fa fa-long-arrow-up' : 'fa fa-pencil'"
                                                            class="text-info mr-1"></i>

                                                        {{ line.details.slice(0, 40) + '...' }}

                                                    </div>

                                                    <div v-if="line.expanded" class="mt-2 text-left"
                                                        style="width:145%;">

                                                        <b-row no-gutters>
                                                            <b-col cols="2" class="mt-3px">Travellers:<i
                                                                    class="fa fa-info-circle text-black"
                                                                    :id="line.id + '_passenger'"></i></b-col>
                                                            <b-tooltip :target="line.id + '_passenger'" triggers="hover"
                                                                placement="bottom">Enter
                                                                travellers SURNAME/FIRST,NEXT</b-tooltip>
                                                            <b-col cols="10"> <b-form-group>
                                                                    <b-input-group>
                                                                        <b-form-input size="sm" v-model="line.passenger"
                                                                            placeholder="Travellers" :disabled="false"
                                                                            @change="updateline(line, index)"></b-form-input>
                                                                        <b-input-group-append>
                                                                            <b-button size="sm"
                                                                                variant="outline-secondary"
                                                                                @click="line.passenger = ''"
                                                                                :disabled="false">
                                                                                <i class="fa fa-remove"></i>
                                                                            </b-button>
                                                                        </b-input-group-append>
                                                                    </b-input-group>

                                                                </b-form-group></b-col>
                                                        </b-row>
                                                        <b-row no-gutters>
                                                            <b-col cols="2" class="mt-3px">Route:<i
                                                                    class="fa fa-info-circle text-black"
                                                                    :id="line.id + '_route'"></i></b-col>
                                                            <b-tooltip :target="line.id + '_route'" triggers="hover"
                                                                placement="bottom">Enter
                                                                IATA
                                                                codes LHR/MIA or name of hotel</b-tooltip>
                                                            <b-col cols="10"> <b-form-group>
                                                                    <b-input-group>
                                                                        <b-form-input size="sm" v-model="line.routing"
                                                                            placeholder="Route" :disabled="false"
                                                                            @change="updateline(line, index)">
                                                                        </b-form-input> <b-input-group-append>
                                                                            <b-button size="sm"
                                                                                variant="outline-secondary"
                                                                                @click="line.routing = ''"
                                                                                :disabled="false">
                                                                                <i class="fa fa-remove"></i>
                                                                            </b-button>
                                                                        </b-input-group-append>
                                                                    </b-input-group>

                                                                </b-form-group></b-col>
                                                        </b-row>
                                                        <b-row no-gutters>
                                                            <b-col cols="2" class="mt-3px">Remark:<i
                                                                    class="fa fa-info-circle text-black"
                                                                    :id="line.id + 'remark'"></i></b-col>
                                                            <b-tooltip :target="line.id + 'remark'" triggers="hover"
                                                                placement="bottom">Enter
                                                                remark
                                                                info about charge</b-tooltip>
                                                            <b-col cols="10"> <b-form-group label-for="notes"
                                                                    label-cols="12">
                                                                    <b-form-textarea id="notes" v-model="line.remark"
                                                                        placeholder="Notes" rows="6" max-rows="6"
                                                                        class="smalltextarea px-2 py-1 font-12px"
                                                                        :disabled="false"></b-form-textarea>
                                                                </b-form-group></b-col>
                                                            <!-- <b-col cols="9"> <b-form-group>
                                                                    <b-input-group>
                                                                        <b-form-input size="sm" v-model="line.remark"
                                                                            placeholder="Remark" :disabled="false"
                                                                            @change="updateline(line, index)"></b-form-input>
                                                                        <b-input-group-append>
                                                                            <b-button size="sm"
                                                                                variant="outline-secondary"
                                                                                @click="line.remark = ''"
                                                                                :disabled="false">
                                                                                <i class="fa fa-remove"></i>
                                                                            </b-button>
                                                                        </b-input-group-append>
                                                                    </b-input-group>

                                                                </b-form-group></b-col> -->
                                                        </b-row>
                                                        <b-row no-gutters>
                                                            <b-col cols="2" class="mt-3px">DateTravel:<i
                                                                    class="fa fa-info-circle text-black"
                                                                    :id="line.id + 'traveldate'"></i>
                                                            </b-col>
                                                            <b-tooltip :target="line.id + 'traveldate'" triggers="hover"
                                                                placement="bottom">Travel dates from - to </b-tooltip>
                                                            <b-col cols="5">
                                                                <b-form-group :id="line.id + 'traveldate1'">
                                                                    <b-input-group>
                                                                        <daterangepicker class="w-auto sm" size="sm"
                                                                            ref="start_at" v-model="line.start_at_pick"
                                                                            :opens="'right'" :locale-data="{
                                                                                direction: 'ltr',
                                                                                format: 'dd/mm/yy HH:MM',
                                                                                daysOfWeek: [
                                                                                    'Sun',
                                                                                    'Mon',
                                                                                    'Tue',
                                                                                    'Wed',
                                                                                    'Thu',
                                                                                    'Fri',
                                                                                    'Sat',
                                                                                ],
                                                                                monthNames: [
                                                                                    'January',
                                                                                    'February',
                                                                                    'March',
                                                                                    'April',
                                                                                    'May',
                                                                                    'June',
                                                                                    'July',
                                                                                    'August',
                                                                                    'September',
                                                                                    'October',
                                                                                    'November',
                                                                                    'December',
                                                                                ],
                                                                                firstDay: 1,
                                                                                applyLabel: 'OK',
                                                                                cancelLabel: 'Cancel',
                                                                            }" :ranges="false" :showDropdowns="true"
                                                                            :single-date-picker="'true'"
                                                                            :timePicker="true" :timePicker24Hour="true"
                                                                            :time-picker-increment="1"
                                                                            @update="pick_date($event, 'start_at', line)">
                                                                        </daterangepicker>
                                                                        <b-input-group-append>
                                                                            <b-button size="sm"
                                                                                variant="outline-secondary" @click="line.start_at_pick = {
                                                                                    startDate: null,
                                                                                    endDate: null,
                                                                                }
                                                                                    ">
                                                                                <i class="fa fa-remove"></i>
                                                                            </b-button>
                                                                        </b-input-group-append>
                                                                    </b-input-group>
                                                                </b-form-group>
                                                            </b-col>
                                                            <b-tooltip :target="line.id + 'traveldate1'"
                                                                triggers="hover" placement="bottom">Travel date from
                                                            </b-tooltip>
                                                            <b-col class="pl-1" cols="5">
                                                                <b-form-group :id="line.id + 'traveldate2'">
                                                                    <b-input-group>
                                                                        <daterangepicker class="w-auto sm" size="sm"
                                                                            ref="end_at" v-model="line.end_at_pick"
                                                                            :opens="'right'" :locale-data="{
                                                                                direction: 'ltr',
                                                                                format: 'dd/mm/yy HH:MM',
                                                                                daysOfWeek: [
                                                                                    'Sun',
                                                                                    'Mon',
                                                                                    'Tue',
                                                                                    'Wed',
                                                                                    'Thu',
                                                                                    'Fri',
                                                                                    'Sat',
                                                                                ],
                                                                                monthNames: [
                                                                                    'January',
                                                                                    'February',
                                                                                    'March',
                                                                                    'April',
                                                                                    'May',
                                                                                    'June',
                                                                                    'July',
                                                                                    'August',
                                                                                    'September',
                                                                                    'October',
                                                                                    'November',
                                                                                    'December',
                                                                                ],
                                                                                firstDay: 1,
                                                                                applyLabel: 'OK',
                                                                                cancelLabel: 'Cancel',
                                                                            }" :ranges="false" :showDropdowns="true"
                                                                            :single-date-picker="'true'"
                                                                            :timePicker="true" :timePicker24Hour="true"
                                                                            :time-picker-increment="1"
                                                                            @update="pick_date($event, 'end_at', line)">
                                                                        </daterangepicker>
                                                                        <b-input-group-append>
                                                                            <b-button size="sm"
                                                                                variant="outline-secondary" @click="line.end_at_pick = {
                                                                                    startDate: null,
                                                                                    endDate: null,
                                                                                }
                                                                                    ">
                                                                                <i class="fa fa-remove"></i>
                                                                            </b-button>
                                                                        </b-input-group-append>
                                                                    </b-input-group>
                                                                </b-form-group>
                                                            </b-col>
                                                            <b-tooltip :target="line.id + 'traveldate2'"
                                                                triggers="hover" placement="bottom">Travel date to
                                                            </b-tooltip>

                                                        </b-row>
                                                        <b-row class="divider mt-1 mb-2" no-gutters></b-row>
                                                        <!--
                                                        <b-row no-gutters>
                                                            <b-col cols="3" class="mt-3px">Notes:<i
                                                                    class="fa fa-info-circle text-black"
                                                                    :id="line.id + 'notes'"></i></b-col>
                                                            <b-tooltip :target="line.id + 'notes'" triggers="hover"
                                                                placement="bottom">Original
                                                                notes</b-tooltip>
                                                            <b-col cols="9"> <b-form-group label-for="notes"
                                                                    label-cols="12">
                                                                    <b-form-textarea id="notes" v-model="line.notes"
                                                                        placeholder="Notes" rows="6" max-rows="6"
                                                                        class="smalltextarea"
                                                                        :disabled="false"></b-form-textarea>
                                                                </b-form-group></b-col>
                                                        </b-row> -->
                                                        <b-row no-gutters>

                                                            <b-col cols="2" class="mt-5px">Payment<i
                                                                    class="fa fa-info-circle text-black"
                                                                    :id="line.id + 'payby'"></i></b-col>
                                                            <b-tooltip :target="line.id + 'payby'" triggers="hover"
                                                                placement="bottom">Pay
                                                                method / Type / VAT Rate
                                                            </b-tooltip>
                                                            <b-col cols="5" class=" mt-n2"> <b-form-group label="PayBy"
                                                                    label-for="payby" label-cols="12">
                                                                    <b-input-group>
                                                                        <treeselect placeholder="Select payby..."
                                                                            searchPromptText="Type at least 3 chars..."
                                                                            v-model="line.payby" :clearable="true"
                                                                            :multiple="false" :disabled="false"
                                                                            :async="true"
                                                                            :load-options="treeselect_loadPAYBY"
                                                                            :show-count="true"
                                                                            :flatten-search-results="true"
                                                                            :disable-branch-nodes="true"
                                                                            :matchKeys="['id']" search-nested>
                                                                            <div slot="value-label"
                                                                                slot-scope="{ node }">
                                                                                {{ node.raw.id }}
                                                                            </div>
                                                                        </treeselect>
                                                                    </b-input-group>
                                                                    <!-- <b-input-group>
                                                                        <b-form-input size="sm" v-model="line.payby"
                                                                            placeholder="PayBy"
                                                                            :disabled="true"></b-form-input>
                                                                        <b-input-group-append>
                                                                            <b-button size="sm"
                                                                                variant="outline-secondary"
                                                                                @click="line.payby = ''"
                                                                                :disabled="true">
                                                                                <i class="fa fa-remove"></i>
                                                                            </b-button>
                                                                        </b-input-group-append>
                                                                    </b-input-group> -->

                                                                </b-form-group></b-col>
                                                            <b-col cols="3" class="pl-1 mt-n2">
                                                                <b-form-group class="mb-3px" label="Supplier Type"
                                                                    label-for="type" label-cols="12">
                                                                    <b-input-group>
                                                                        <treeselect id="type" placeholder=""
                                                                            :clearable="false" v-model="line.type"
                                                                            :options="suppliertype_options"
                                                                            :disable-branch-nodes="true"
                                                                            :show-count="true">
                                                                            <div slot="value-label"
                                                                                slot-scope="{ node }">
                                                                                {{ node.raw.id }}
                                                                            </div>
                                                                        </treeselect>

                                                                    </b-input-group>
                                                                </b-form-group>

                                                                <!-- <b-form-group>
                                                                    <b-input-group>
                                                                        <b-form-input size="sm" v-model="line.vatr"
                                                                            placeholder="VAT Rate"
                                                                            :disabled="false"></b-form-input>
                                                                        <b-input-group-append>
                                                                            <b-button size="sm"
                                                                                variant="outline-secondary"
                                                                                @click="line.vatr = ''"
                                                                                :disabled="false">
                                                                                <i class="fa fa-remove"></i>
                                                                            </b-button>
                                                                        </b-input-group-append>
                                                                    </b-input-group>
                                                                </b-form-group> -->
                                                            </b-col>
                                                            <b-col cols="2" class="pl-1 mt-n2">
                                                                <b-form-group class="mb-3px" label="VAT Rate"
                                                                    label-for="vatr" label-cols="12">
                                                                    <b-input-group>
                                                                        <treeselect id="vatcode" placeholder=""
                                                                            :clearable="false" v-model="line.vatr"
                                                                            :options="options_vatrates"
                                                                            :disable-branch-nodes="true"
                                                                            :show-count="true">
                                                                            <div slot="value-label"
                                                                                slot-scope="{ node }">
                                                                                {{ node.raw.id }}
                                                                            </div>
                                                                        </treeselect>

                                                                    </b-input-group>
                                                                </b-form-group>
                                                            </b-col>
                                                        </b-row>
                                                        <b-row no-gutters>

                                                            <b-col cols="2" class="mt-3px">Currency:<i
                                                                    class="fa fa-info-circle text-black"
                                                                    :id="line.id + 'currency'"></i></b-col>
                                                            <b-tooltip :target="line.id + 'currency'" triggers="hover"
                                                                placement="bottom">Currency of payment
                                                            </b-tooltip>
                                                            <b-col cols="10"> <b-form-group>
                                                                    <b-input-group>
                                                                        <b-form-input size="sm"
                                                                            v-model="line.costcurrency"
                                                                            placeholder="Currency"
                                                                            :disabled="true"></b-form-input>
                                                                        <b-input-group-append>
                                                                            <b-button size="sm"
                                                                                variant="outline-secondary"
                                                                                @click="line.costcurrency = ''"
                                                                                :disabled="true">
                                                                                <i class="fa fa-remove"></i>
                                                                            </b-button>
                                                                        </b-input-group-append>
                                                                    </b-input-group>

                                                                </b-form-group></b-col>
                                                        </b-row>
                                                        <b-row no-gutters>

                                                            <b-col cols="2" class="mt-3px">Tkt:/Ref:<i
                                                                    class="fa fa-info-circle text-black"
                                                                    :id="line.id + 'referenceno'"></i></b-col>
                                                            <b-tooltip :target="line.id + 'referenceno'"
                                                                triggers="hover" placement="bottom">Transaction ID
                                                            </b-tooltip>
                                                            <b-col cols="10"> <b-form-group>
                                                                    <b-input-group>
                                                                        <b-form-input size="sm"
                                                                            v-model="line.referenceno"
                                                                            placeholder="Tkt/Ref"
                                                                            :disabled="true"></b-form-input>
                                                                        <b-input-group-append>
                                                                            <b-button size="sm"
                                                                                variant="outline-secondary"
                                                                                @click="line.referenceno = ''"
                                                                                :disabled="true">
                                                                                <i class="fa fa-remove"></i>
                                                                            </b-button>
                                                                        </b-input-group-append>
                                                                    </b-input-group>

                                                                </b-form-group></b-col>
                                                        </b-row>

                                                        <b-row class="my-2">
                                                            <b-col cols="6">
                                                                <!-- <b-button squared size="sm" class="xs py-0"
                                                                    :variant="'outline-primary'"
                                                                    :disabled="value.posted" @click="updateit(line)">
                                                                    Update It
                                                                </b-button> -->
                                                            </b-col>

                                                            <b-col class="text-left">
                                                                <b-button size="sm" class="xs py-0" squared
                                                                    variant="secondary"
                                                                    @click="line.expanded = !line.expanded">
                                                                    <i class="fa fa-arrow-up pr-1"></i>
                                                                    Close
                                                                </b-button>
                                                            </b-col>
                                                        </b-row>
                                                    </div>


                                                </td>
                                                <!-- 
                                                <td>
                                                    <div class="text-center form-control form-control-sm disabled">
                                                        {{ line.currency }}</div>
                                                </td> -->

                                                <!-- <td class="w-50px">
                                                    <b-form-group class="mb-3px">
                                                        <b-input-group>
                                                            <treeselect id="vatcode" placeholder="" :clearable="false"
                                                                v-model="line.vatr" :options="options_vatrates"
                                                                :disable-branch-nodes="true" :show-count="true">
                                                                <div slot="value-label" slot-scope="{ node }">
                                                                    {{ node.raw.id }}
                                                                </div>
                                                            </treeselect>

                                                        </b-input-group>
                                                    </b-form-group>
                                                </td> -->
                                                <!-- <td class="w-10pct">
                                                    <b-form-group class="mb-3px">
                                                        <b-input-group>
                                                            <treeselect placeholder="Select payby..."
                                                                searchPromptText="Type at least 3 chars..."
                                                                v-model="line.payby" :clearable="true" :multiple="false"
                                                                :async="true" :load-options="treeselect_loadPAYBY"
                                                                :show-count="true" :flatten-search-results="true"
                                                                :disable-branch-nodes="true" :matchKeys="['id']"
                                                                search-nested>
                                                                <div slot="value-label" slot-scope="{ node }">
                                                                    {{ node.raw.id }}
                                                                </div>
                                                            </treeselect>
                                                        </b-input-group>
                                                    </b-form-group>
                                                </td> -->
                                                <td class="w-120px">
                                                    <b-form-group class="mb-3px">
                                                        <b-input-group>
                                                            <treeselect placeholder="Select blac..."
                                                                searchPromptText="Type at least 3 chars..."
                                                                v-model="line.blac" :clearable="true" :multiple="false"
                                                                :async="true" :load-options="treeselect_loadBLAC"
                                                                :show-count="true" :flatten-search-results="true"
                                                                :disable-branch-nodes="true" :matchKeys="['id']"
                                                                search-nested>
                                                                <div slot="value-label" slot-scope="{ node }">
                                                                    {{ node.raw.id }}
                                                                </div>
                                                            </treeselect>
                                                        </b-input-group>
                                                    </b-form-group>
                                                    <!-- <b-form-group class="mb-3px">
                                                        <b-input-group>
                                                            <b-form-input size="sm" v-model="line.blac"
                                                                placeholder="BL A/C" class="text-right"
                                                                :formatter="nocomma" :disabled="false"></b-form-input>
                                                        </b-input-group>
                                                    </b-form-group> -->
                                                </td>
                                                <td class="w-100px" :id="'cost_' + line.referenceno">
                                                    <b-form-group class="mb-3px">
                                                        <b-input-group>
                                                            <b-form-input size="sm" v-model="line.cost"
                                                                placeholder="Cost" class="text-right text-red"
                                                                :formatter="nocomma" :disabled="false"></b-form-input>
                                                        </b-input-group>
                                                    </b-form-group>
                                                    <b-tooltip :target="'cost_' + line.referenceno" placement="left">
                                                        <u>Currency</u><br />
                                                        <span v-if="line.cost">{{ line.costcurrency }} : {{ line.cost
                                                            }}</span>
                                                        <span v-if="line.costlocal"><br />{{ line.costlocalcurrency }} :
                                                            {{ line.costlocal }}</span>
                                                    </b-tooltip>
                                                </td>

                                                <td class="w-80px">
                                                    <div class="text-center form-control form-control-sm disabled">
                                                        <span class="strong"
                                                            :style="parseFloat(line.margin) <= 0 ? 'color:#dc3545' : 'color:#3cb450'">{{
                                                                line.margin }} %</span>
                                                    </div>
                                                </td>

                                                <!-- <td>
                                                    <div
                                                        class="w-50px text-center form-control form-control-sm disabled">
                                                        {{ line.qty }}</div>
                                                </td> -->

                                                <td class="w-100px">
                                                    <!-- <b-form-group class="mb-3px">
                                                        <b-input-group>
                                                            <b-form-input size="sm" v-model="line.sale"
                                                                placeholder="Sale" class="text-right" :disabled="true"
                                                                trim></b-form-input>
                                                        </b-input-group>
                                                    </b-form-group> -->
                                                    <b-form-group class="mb-3px">
                                                        <b-input-group>
                                                            <b-form-input size="sm" v-model="line.sale"
                                                                placeholder="Sale" class="text-right"
                                                                :formatter="nocomma" :disabled="false"></b-form-input>
                                                            <!-- :disabled="sector.total == 'N/A' ? true : false" -->
                                                        </b-input-group>
                                                    </b-form-group>

                                                </td>
                                                <td class="w-100px">
                                                    <!-- <b-form-group class="mb-3px">
                                                        <b-input-group>
                                                            <b-form-input size="sm" v-model="line.vat" placeholder="VAT"
                                                                class="text-right" :disabled="true"
                                                                :formatter="nocomma"></b-form-input>
                                                        </b-input-group>
                                                    </b-form-group> -->
                                                    <b-form-group class="mb-3px">
                                                        <b-input-group>
                                                            <b-form-input size="sm" v-model="line.vat" placeholder="VAT"
                                                                class="text-right" :formatter="nocomma"
                                                                :disabled="false"></b-form-input>
                                                            <!-- :disabled="sector.total == 'N/A' ? true : false" -->
                                                        </b-input-group>
                                                    </b-form-group>
                                                </td>
                                                <td class="w-120px">
                                                    <b-form-group class="mb-3px">
                                                        <b-input-group>
                                                            <b-form-input size="sm" v-model="line.total"
                                                                placeholder="Total" class="text-right"
                                                                :formatter="nocomma" :disabled="true"></b-form-input>
                                                            <!-- :disabled="sector.total == 'N/A' ? true : false" -->
                                                            <b-input-group-append>
                                                                <b-button size="sm" variant="outline-secondary"
                                                                    @click="line.sale = '0'"
                                                                    :disabled="lines.filter(o => o.id == line.id).length == 0">
                                                                    <i class="fa fa-remove"></i>
                                                                </b-button>
                                                            </b-input-group-append>
                                                        </b-input-group>
                                                    </b-form-group>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td :id="'lines-add_' + value.id" class="w-30px">
                                                    <i class="fa fa-plus-square text-info font-14px"
                                                        @click="addLine"></i>
                                                    <b-tooltip :target="'lines-add_' + value.id" placement="top">Click
                                                        to duplicate a new line
                                                        to this invoice</b-tooltip>
                                                </td>
                                                <!-- <td :id="'lines-sheet_' + value.id" class="w-30px">
                                                    <i class="fa fa fa-ellipsis-h text-info font-14px"
                                                        @click="showsheetlines = !showsheetlines"></i>
                                                    <b-tooltip :target="'lines-sheet_' + value.id" placement="top">Click
                                                        to paste data lines
                                                        from a spreadsheet</b-tooltip>
                                                </td> -->
                                                <td colspan="12">
                                                    <b-form-group v-if="showsheetlines" label-for="sheetlines"
                                                        label-cols="12">
                                                        <b-form-textarea id="sheetlines" v-model="sheetlines"
                                                            placeholder="Paste data lines from spreadsheet" rows="8"
                                                            max-rows="8" class="smalltextarea"
                                                            :disabled="false"></b-form-textarea>
                                                    </b-form-group>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td class="pl-1 text-left pt-1" colspan="10">
                                                    <b-row class="mt-2" no-gutters>
                                                        <b-col cols="auto" class="text-left">
                                                            <b-button size="sm" class="xs line-height-0"
                                                                :variant="'outline-primary'" @click="saveit"
                                                                :disabled="value.posted">
                                                                Save It
                                                            </b-button>
                                                        </b-col>
                                                        <b-col class="text-left ml-2 mt-0">
                                                            <div v-if="busy">
                                                                <i class="fa fa-spinner fa-spin text-primary"></i>
                                                            </div>
                                                            <div v-else>
                                                                <span v-html="message_saveit"></span>
                                                            </div>
                                                        </b-col>
                                                    </b-row>

                                                </td>

                                                <!-- <td colspan="5" class="pr-1 text-right"></td> -->

                                                <td><span class="h6 strong">Total</span></td>
                                                <td>
                                                    <b-form-group class="mb-3px">
                                                        <b-input-group>
                                                            <b-form-input size="sm" v-model="value.cost"
                                                                placeholder="Cost GBP"
                                                                class="text-right text-red strong" :disabled="true"
                                                                :formatter="nocomma"></b-form-input>
                                                        </b-input-group>
                                                    </b-form-group>
                                                </td>
                                                <td>
                                                    <b-form-group class="mb-3px">
                                                        <b-input-group>
                                                            <b-form-input size="sm" v-model="value.margin"
                                                                placeholder="Margin" class="text-right strong"
                                                                :class="parseFloat(value.margin) > 0 ? 'text-primary' : 'text-red'"
                                                                :disabled="true" :formatter="nocomma"></b-form-input>
                                                        </b-input-group>
                                                    </b-form-group>
                                                </td>
                                                <td>
                                                    <b-form-group class="mb-3px">
                                                        <b-input-group>
                                                            <b-form-input size="sm" v-model="value.sale"
                                                                placeholder="Net" class="text-right strong"
                                                                :disabled="true" :formatter="nocomma"></b-form-input>
                                                        </b-input-group>
                                                    </b-form-group>
                                                </td>
                                                <td>
                                                    <b-form-group class="mb-3px">
                                                        <b-input-group>
                                                            <b-form-input size="sm" v-model="value.vat"
                                                                placeholder="Tax" class="text-right strong"
                                                                :disabled="true" :formatter="nocomma"></b-form-input>
                                                        </b-input-group>
                                                    </b-form-group>
                                                </td>
                                                <td>
                                                    <b-form-group class="mb-3px">
                                                        <b-input-group>
                                                            <b-form-input size="sm" v-model="value.total"
                                                                placeholder="Total" class="text-right strong"
                                                                :disabled="true" :formatter="nocomma"></b-form-input>
                                                            <b-input-group-append>
                                                                <b-button size="sm" variant="outline-secondary"
                                                                    @click="value.sale = '0.00'" :disabled="true">
                                                                    <i class="fa fa-remove"></i>
                                                                </b-button>
                                                            </b-input-group-append>
                                                        </b-input-group>
                                                    </b-form-group>
                                                </td>
                                                <td></td>
                                            </tr>
                                            <tr v-if="1 == 0">
                                                <td colspan="12" class="pr-1 text-right"><span class="h6 strong">Admin
                                                        Fee</span></td>
                                                <td>
                                                    <b-form-group>
                                                        <b-input-group>
                                                            <b-form-input size="sm" v-model="value.adminfee"
                                                                placeholder="Admin Fee" class="text-right strong"
                                                                :formatter="nocomma"></b-form-input>
                                                            <b-input-group-append>
                                                                <b-button size="sm" variant="outline-secondary"
                                                                    @click="value.adminfee = '0.00'">
                                                                    <i class="fa fa-remove"></i>
                                                                </b-button>
                                                            </b-input-group-append>
                                                        </b-input-group>
                                                    </b-form-group>
                                                </td>
                                            </tr>
                                        </table>
                                    </div>

                                </b-col>
                            </b-row>
                            <!-- {{ travellers }} -->
                            <!-- {{ value.total }} -->
                            <!-- {{ segments }} -->
                            <!-- {{ value.vat }} -->
                        </p>
                    </b-tab>

                    <b-tab>
                        <template #title>
                            <i class="fa fa-wpforms text-primary mr-1"></i> Draft
                        </template>
                        <p class="py-3 px-0">
                        <div class="etr">
                            <b-row>
                                <b-col cols="12">
                                    <b-overlay :show="busy" spinner-type="grow" spinner-variant="primary" rounded="sm">
                                        <r-invoice :showasdraft="true" :item="item" />
                                        <!-- <b-alert v-if="item.message" show :variant="item.level"
                                            class="text-center mt-2 mb-1">
                                            <b-row align-v="center" no-gutters><b-col cols="auto mr-3">
                                                    <i class="fa fa-info-circle fa-2x"></i></b-col>
                                                <b-col> <span
                                                        v-html="item.message.split('\n').join('<br/>')"></span></b-col></b-row>
                                        </b-alert> -->
                                    </b-overlay>
                                    <b-card-footer class="mt-2 ml-1">
                                        <b-row>
                                            <b-col class="text-left">
                                                <b-row class="mt-1">
                                                    <b-col>
                                                        <b-button squared size="sm" class="ml-1" variant="warning"
                                                            @click="showledgers = !showledgers" :pressed="!showledgers">
                                                            Ledgers<i :class="showledgers ? 'fa fa-arrow-up ml-1' : 'fa fa-arrow-down ml-1'
                                                                "></i>
                                                        </b-button>
                                                    </b-col>
                                                    <b-col>
                                                        <div v-if="busy">
                                                            <i class="fa fa-spinner fa-spin text-primary"></i>
                                                            <span class="text-success ml-2">Preparing set of
                                                                invoice(s)</span>
                                                        </div>
                                                        <div v-else>
                                                            <span v-html="message"></span>
                                                        </div>
                                                    </b-col>
                                                </b-row>
                                            </b-col>
                                            <b-col class="text-right">
                                                <b-button-group class="z-0" v-if="items.length > 1">
                                                    <b-button squared size="sm" @click="render()"
                                                        variant="outline-primary" class="mr-1 h-28px">
                                                        <i class="fa fa-refresh"></i>
                                                    </b-button>

                                                    <b-pagination hide-ellipsis v-model="page"
                                                        :total-rows="items.length" :per-page="1" align="right"
                                                        size="sm"></b-pagination>
                                                </b-button-group>


                                            </b-col>

                                        </b-row>

                                    </b-card-footer>
                                    <div v-if="showledgers" class="mx-4">
                                        <b-row>
                                            <b-card class="border-none w-100pct">
                                                <b-card-title class="text-left">B/L Item Headers</b-card-title>
                                                <d-table classdivtable="availtable datatable" refid="blitemheaders"
                                                    :items="data.BL" :showpages="false" :showtoolbar="false">
                                                </d-table>
                                            </b-card>
                                        </b-row>
                                        <b-row>
                                            <b-card class="border-none w-100pct">
                                                <b-card-title class="text-left">S/L Item Headers</b-card-title>
                                                <d-table classdivtable="availtable datatable" refid="blitemheaders"
                                                    :items="SL" :showpages="false" :showtoolbar="false">
                                                </d-table> </b-card></b-row>
                                        <b-row>
                                            <b-card class="border-none w-100pct">
                                                <b-card-title class="text-left">l Item Lines</b-card-title>
                                                <d-table classdivtable="availtable datatable" refid="blitemheaders"
                                                    :items="data.SL[0].items" :showpages="false" :showtoolbar="false">
                                                </d-table> </b-card></b-row>
                                    </div>
                                </b-col>
                            </b-row>
                        </div>
                        </p>
                    </b-tab>
                    <b-tab @click="refno = refno_options[0].id">
                        <template #title>
                            <i class="fa fa-plus-square text-primary mr-1"></i> Additional
                        </template>
                        <b-row class="mt-2">
                            <b-col cols="12" sm="6" md="4" xl="3">
                                <b-form-group label-cols="12" label="CreditNo ( Invoice to Credit )" label-size="sm">
                                    <b-input-group>
                                        <b-form-input v-model="creditno" :debounce="500"
                                            placeholder="CreditNo"></b-form-input>
                                        <b-input-group-append>
                                            <b-button size="sm" squared variant="outline-secondary"
                                                @click="creditno = null">
                                                <i class="fa fa-remove"></i>
                                            </b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" sm="6" md="4" xl="3">
                                <b-form-group label="TicketNo ( for Costs )" label-for="ticketno" label-cols="12">
                                    <b-input-group>
                                        <b-form-input type="text" v-model="ticketno" placeholder="Enter ticketno"
                                            trim></b-form-input>
                                        <b-input-group-append>
                                            <b-button size="sm" variant="outline-secondary" @click="ticketno = ''">
                                                <i class="fa fa-remove"></i>
                                            </b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" sm="6" md="4" xl="3">
                                <b-form-group label="Routing" label-for="routing" label-cols="12">
                                    <b-input-group>
                                        <b-form-input type="text" v-model="routing" placeholder="Enter routing"
                                            trim></b-form-input>
                                        <b-input-group-append>
                                            <b-button size="sm" variant="outline-secondary" @click="routing = ''">
                                                <i class="fa fa-remove"></i>
                                            </b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                </b-form-group>
                            </b-col>
                        </b-row>

                        <b-row class="mt-2">
                            <b-col cols="12">
                                <b-form-group
                                    :label="'Conferma IDs for invoice lines ( count: ' + confermano.length + ' )'"
                                    label-for="id" label-cols="12">
                                    <b-input-group class="z-0">
                                        <b-form-tags input-id="id" v-model="confermano" class="min-h-29"
                                            tag-variant="primary" separator=" ,;" placeholder="Paste ID (333..,333...)"
                                            size="sm" add-button-text="+" add-on-change remove-on-delete
                                            add-button-variant="outline-primary"></b-form-tags>

                                        <b-input-group-append>
                                            <b-button size="sm" variant="outline-secondary" @click="confermano = []">
                                                <i class="fa fa-remove"></i>
                                            </b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <p>

                            <b-row no-gutters class="my-2">
                                <b-col class="divider"></b-col>
                            </b-row>
                            <b-row>
                                <b-col cols="12" sm="6" md="4" xl="3">
                                    <b-form-group label-cols="12" label="RefNo" label-size="sm">
                                        <treeselect id="refno" placeholder="Select refno..." :clearable="false"
                                            v-model="refno" :options="refno_options" :disable-branch-nodes="true"
                                            :show-count="true" />
                                    </b-form-group>
                                </b-col>
                                <b-col cols="12">
                                    <b-form-group label="Original Notes" label-for="notes" label-cols="12">
                                        <b-form-textarea id="notes" v-model="notes" placeholder="Notes" rows="8"
                                            max-rows="8" class="smalltextarea" :disabled="false"></b-form-textarea>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                        </p>
                    </b-tab>

                </b-tabs>

            </b-card-body>

            <b-row v-if="lines.filter(l => l.start_at == 'Invalid date').length > 0" class="px-0">
                <b-col>
                    <b-alert :show="true" variant="danger">
                        <b-row align-v="center" no-gutters class="font-13px"><b-col cols="auto mr-3">
                                <i class="fa fa-exclamation-circle fa-2x"></i></b-col>
                            <b-col>
                                Please add a valid datetravel.</b-col></b-row>
                    </b-alert></b-col>
            </b-row>

            <!-- <b-row class="px-1">
                <b-col cols="auto" class="text-left mb-2">
                    <b-button squared size="sm" :variant="'outline-primary'" @click="saveit" :disabled="value.posted">
                        <i class="fa fa-check"></i>
                        Save It
                    </b-button>
                </b-col>
            </b-row> -->

            <!-- posted={{ value.posted }} -->

            <template #footer>
                <b-row class="mx-n4">

                    <b-col cols="auto" class="text-left">
                        <b-button squared size="sm" :variant="postit_variant"
                            :disabled="value.posted || postit_variant == 'dark'" @click="postit">
                            <i :class="postit_icon"></i>
                            {{ postit_label }}
                        </b-button>
                    </b-col>
                    <!-- <b-col cols="auto" class="text-left" v-if="lines.length > 1">
                        <input id="perline" style="height: 15px; margin-top: 3px" type="checkbox" v-model="perline"
                            :disabled="value.posted">
                        <span class="ml-2" @click="perline = !perline">Invoice per line</span>
                    </b-col> -->
                    <b-col align-self="center"><span v-if="!value.posted && !busy && !draft"
                            v-html="readymessage"></span> </b-col>
                    <b-col cols="auto">
                        <b-row>
                            <b-col cols="auto" align-self="center">
                                <h5 :class="ZColour">
                                    {{ ZTotal }}
                                </h5>
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>
                <b-row class="mx-n4">
                    <b-col cols="12">
                        <b-alert v-if="item.message" show :variant="item.level" class="text-center mt-2 mb-1">
                            <b-row align-v="center" no-gutters class="font-13px"><b-col cols="auto mr-0">
                                    <i class="fa fa-exclamation-circle fa-2x"></i></b-col>
                                <b-col> <span class="alert-message"
                                        v-html="item.message.split('\n').join('<br/>')"></span></b-col></b-row>
                        </b-alert>
                    </b-col>
                </b-row>
            </template>

        </b-card>
    </div>
</template>

<script>
import gql from "graphql-tag";

export default {
    name: "i-binvoice",
    async mounted() {
        await this.load_agents()
    },
    data() {
        return {
            tabindex: 0,
            message: "",
            message_saveit: "",
            busy: false,
            draft: false,
            expanded: false,
            perline: false,
            refno: null,
            creditno: null,
            ticketno: null,
            routing: null,
            confermano: [],
            notes: null,
            showsheetlines: false,
            sheetlines: null,
            refno_options: [],
            options_vatrates: [
                { id: "S", label: "S | 20%" },
                { id: "Z", label: "Z | 0%" },
            ],
            suppliertype_options: [],
            lines: [],
            mifields: [],
            requirement: {},
            page: 1,
            level: ["success"],
            ss: [],
            items: [],
            item: {
                ref: ""
            },
            data: null,
            SL: [],
            showledgers: false,
            prefix: "IM",
            level: ["success"],
            options_prefix: [
                { id: "IM", label: "IM | Manual " },
                { id: "CM", label: "CM | Credit" },
            ],
            options_level: [
                { id: "success", label: "Success" },
                { id: "warning", label: "Warning" },
                { id: "danger", label: "Danger" },
            ],
            options_agent: []
        };
    },
    async mounted() {
        console.log("mounted i-binvoice");
        try {
            const response = await this.$apollo.query({
                query: gql`
                        query suppliertypes {
                        suppliertypes {
                            id
                            label
                            faicon
                        }
                        }
                    `,
            });
            this.suppliertype_options = response.data.suppliertypes;
        } catch (error) {
            console.log(error);
        }
    },
    props: {
        value: { type: Object, required: true },
        title: { type: String, default: "" },
    },
    computed: {
        readymessage() {
            return (
                "<span class='text-primary'>Ready to submit " +
                this.invoicecount +
                " document(s).</span>"
            );
        },
        invoicecount() {
            return this.perline ? this.value.lines.length : 1;
            if (this.value.passengers) {
                let yourrefs = [
                    ...new Set(
                        this.value.passengers.map((item) =>
                            item.yourref ? item.yourref : null
                        )
                    ),
                ];
                count = yourrefs.length;
            }
            return count;
        },
        ZTotal() {
            let sale = 0.0;
            let cost = 0.0;
            let markup = 0.00
            let margin = 0
            let vat = 0
            for (var k = 0; k < this.lines.length; k++) {
                cost += parseFloat(this.lines[k].cost)
                sale += parseFloat(this.lines[k].sale)

                if (this.lines[k].vatr == "S") {
                    this.lines[k].vat = (parseFloat(this.lines[k].sale) * 0.2).toFixed(2)
                } else {
                    this.lines[k].vat = (0).toFixed(2)
                }
                vat += parseFloat(this.lines[k].vat)

                if (parseFloat(this.lines[k].sale) != 0) {
                    this.lines[k].margin = 1 - parseFloat(this.lines[k].cost) / parseFloat(this.lines[k].sale)
                } else {
                    this.lines[k].margin = 0
                }
                this.lines[k].margin = (this.lines[k].margin * 100).toFixed(2)

                this.lines[k].markup = (parseFloat(this.lines[k].sale) - parseFloat(this.lines[k].cost)).toFixed(2)
                markup += parseFloat(this.lines[k].markup)

                this.lines[k].total = (parseFloat(this.lines[k].sale) + parseFloat(this.lines[k].vat)).toFixed(2)
            }

            this.value.cost = cost.toFixed(2)
            this.value.sale = sale.toFixed(2)

            this.value.vat = vat.toFixed(2)
            this.value.total = (sale + vat).toFixed(2)
            if (sale != 0) {
                this.value.margin = ((1 - parseFloat(cost) / parseFloat(sale)) * 100).toFixed(2)
            } else {
                this.value.margin = (0).toFixed(2)
            }
            this.value.margin += " %"

            return (
                this.lines.length + " lines * ( " + cost.toFixed(2) + " + " + markup.toFixed(2) + " = " + (sale + vat).toFixed(2) + " ) = GBP " + (sale + vat).toFixed(2))

        },
        ZColour() {
            let result = "text-primary"
            if (parseFloat(this.value.total) <= 0) {
                result = "text-danger"
            }
            result += " strong mb-0"
            return result
        },
        allLinesChecked() {
            const checked = this.lines.length;
            // // console.log("allAreChecked?", checked);
            return checked === this.value.lines.length
        },
        postit_variant() {
            if (this.busy) {
                return 'warning'
            } else {
                if (parseFloat(this.value.sale) > 0) {
                    return 'primary'
                } else if (parseFloat(this.value.sale) < 0) {
                    return 'danger'
                } else {
                    if (parseFloat(this.value.cost) == 0) {
                        return 'dark'
                    } else {
                        return 'info'
                    }
                }
            }
        },
        postit_icon() {
            if (this.busy) {
                return 'fa fa-spinner fa-spin text-white mr-1'
            } else {
                if (this.value.posted) {
                    return 'fa fa-stack-overflow mr-1'
                } else {
                    if (parseFloat(this.value.sale) == 0 && parseFloat(this.value.cost) == 0) {
                        return 'fa fa-exclamation-circle mr-1'
                    } else {
                        return 'fa fa-paper-plane mr-1'
                    }

                }
            }
        },
        postit_label() {
            if (this.busy) {
                if (this.value.posted) {
                    return 'Posting to Ledgers'
                }
            } else {
                if (this.value.posted) {
                    this.message_saveit = "<span class='text-primary'>Saved it.  " + this.items.map(l => l.ref).sort().join(',') + "</span>";
                    return 'Invoiced on ' + this.items.map(l => l.ref).sort().join(',')
                } else {
                    if (parseFloat(this.value.sale) > 0) {
                        return 'Invoice It'
                    } else if (parseFloat(this.value.sale) < 0) {
                        return 'Credit It'
                    } else {
                        if (parseFloat(this.value.cost) == 0) {
                            return 'User Error?'
                        } else if (parseFloat(this.value.cost) > 0) {
                            return 'BL Invoice'
                        } else {
                            return 'BL Credit'
                        }
                    }
                }
            }
        },
    },
    watch: {
        tabindex: {
            immediate: true,
            async handler(newVal, oldVal) {
                if (newVal == 1) {
                    await this.renderit()
                }
            }
        },
        perline: {
            immediate: true,
            async handler(newVal, oldVal) {
                await this.renderit()
            }
        },
        refno: {
            immediate: true,
            async handler(newVal, oldVal) {
                await this.load_bookingform(newVal)
            }
        },
        value: {
            immediate: true,
            async handler(newVal, oldVal) {
                this.item = {}
                this.travellers = []
                this.creditno = null
                this.ticketno = null
                this.routing = null
                this.confermano = []
                this.lines = newVal.lines

                for (var k = 0; k < this.lines.length; k++) {
                    let pick = null
                    if (this.lines[k].start_at && this.lines[k].start_at != "Invalid date") {
                        pick = this.lines[k].start_at
                    }
                    this.lines[k].start_at_pick = {
                        startDate: pick,
                        endDate: pick,
                    }
                }

                for (var k = 0; k < this.lines.length; k++) {
                    let pick = null
                    if (this.lines[k].end_at && this.lines[k].end_at != "Invalid date") {
                        pick = this.lines[k].end_at
                    }
                    this.lines[k].end_at_pick = {
                        startDate: pick,
                        endDate: pick,
                    }
                }

                this.item.tags = newVal.tags ? newVal.tags : "{}";
                this.item.slac = newVal.slac;
                this.item.yourref = newVal.yourref;
                this.item.stype = this.lines[0].type;
                await this.load_mifields();

                this.tabindex = 0
                this.perline = false
                let refnos = newVal.referenceno.split(",")
                this.refno_options = []
                for (var i = 0; i < refnos.length; i++) {
                    this.refno_options.push({ id: refnos[i], label: refnos[i] })
                }
                this.message_saveit = ""



            }
        },
        page: {
            async handler(newVal, oldVal) {
                if (newVal) {
                    if (newVal <= this.ss.length) {
                        this.item = this.ss[newVal - 1];

                        if (this.item.data) {
                            this.data = JSON.parse(this.item.data);
                            this.SL = [];
                            this.SL.push({ ...this.data.SL[0] });
                            delete this.SL[0].items;
                        }
                    }
                }
            },
        },
        "lines": {
            immediate: true,
            deep: true,
            async handler(newVal, oldVal) {
                console.log("watch:lines.type", newVal);
                await this.load_mifields();
            },
        },
    },
    methods: {
        // async load_mifields() {
        //     // console.log('load_mifields', this.value.referenceno, this.value.tags)
        //     let tags = this.value.tags == null ? null : JSON.parse(this.value.tags)

        //     this.mifields = [];
        //     this.requirement = {}

        //     let variables = {
        //         slac: this.value.slac,
        //         active: "1",
        //     };

        //     const response = await this.$apollo.query({
        //         query: gql`
        //                 query setup_mifields($slac: String, $active: String) {
        //                 setup_mifields(slac: $slac, active: $active) {
        //                     key
        //                     type
        //                     stype
        //                     label
        //                     options
        //                     required
        //                     value
        //                     active
        //                 }
        //                 }
        //             `,
        //         variables,
        //         fetchPolicy: "no-cache",
        //     });
        //     this.mifields = JSON.parse(JSON.stringify(response.data.setup_mifields))
        //     for (var i = 0; i < this.mifields.length; i++) {
        //         if (tags) {
        //             if (tags[this.mifields[i].key]) {
        //                 this.mifields[i].value = tags[this.mifields[i].key];
        //             }
        //         }
        //         if (this.mifields[i].options) {
        //             this.mifields[i].options = JSON.parse(this.mifields[i].options)
        //         }
        //         // SET REQUIREMENTS OBJECT
        //         if (this.mifields[i].required == "1") {
        //             if (this.mifields[i].stype) {
        //                 if (this.mifields[i].stype.includes(this.lines[0].type)) {
        //                     this.requirement[this.mifields[i].key] = this.mifields[i].label;
        //                 }
        //             } else {
        //                 this.requirement[this.mifields[i].key] = this.mifields[i].label;
        //             }
        //         }
        //     }
        // },
        icontype(value) {
            let result = "fa fa-arrows-h"
            switch (value) {
                case "AIR":
                    result = "fa fa-plane text-primary"
                    break;
                case "CAR":
                    result = "fa fa-car text-info"
                    break;
                case "HTL":
                    result = "fa fa-bed text-orange"
                    break;
                case "EMD":
                    result = "fa fa-user-plus text-purple"
                    break;
                case "XFR":
                    result = "fa fa-map-marker text-dark"
                    break;
                case "RAIL":
                    result = "fa fa-train text-danger"
                    break;
            }
            return result
        },
        onlyascii(value) {
            // A SPECIFIC REPLACE
            value = value.split('b').join('')
            value = value.normalize('NFD').replace(/([\u0300-\u036f]|[^\x20-\x7E])/g, '')
            return value
        },
        cliplines() {
            try {
                window.navigator.clipboard.writeText(this.value.referenceno);
            } catch (error) {
                console.log(error)
            }
        },
        linesAll(evt) {
            const list = this.allLinesChecked
                ? []
                : this.value.lines.slice(0, this.value.lines.length);
            this.lines = list;
        },
        toggleLine(evt, index) {
            console.log("toggleLine", evt, index);

            const savedIndex = this.savedIndex;
            this.savedIndex = index;

            // If this is the first pass or no shift key was
            // pressed, just bail.
            if (savedIndex === null || !evt.shiftKey) return;

            // Shift-clicked the same message :-/
            if (index === savedIndex) return;

            // Get the subset of the message list between the
            // two indicies.
            // console.time("toggle range");
            const subset = this.items.slice(
                Math.min(index, savedIndex),
                Math.max(index, savedIndex) + 1
            );
            // Determine the operation based on the checked state
            // of the clicked checkbox.
            const toggleFn = evt.currentTarget.checked
                ? addCheckedSubset
                : removeCheckedSubset;

            this.lines = toggleFn(this.lines, subset);
            console.log("these are checked", this.lines);
            // console.timeEnd("toggle range");
        },
        addLine() {
            let _copy = { ...this.lines[this.lines.length - 1] }
            _copy.cost = (0).toFixed(2)
            _copy.sale = (0).toFixed(2)
            _copy.total = (0).toFixed(2)
            this.lines.push(_copy)
        },
        async setType(index, type) {
            this.lines[index].type = type
        },
        async claimLine(line, agent) {

            let row = {
                id: this.lines[line].id,
            }

            if (!agent && this.lines[line].agent) {
                this.lines[line].claimed = false
                this.lines[line].agent = ""
                row.agent = ""
            } else {
                this.lines[line].claimed = true
                if (agent) {
                    this.lines[line].agent = agent
                    row.agent = agent
                } else {
                    this.lines[line].agent = this.user.initials
                    row.agent = this.user.initials
                }
            }
            let variables = {
                rows: [row]
            };

            try {
                const response = await this.$apollo.mutate({
                    mutation: gql`
                    mutation inventorylines_save(
                        $rows: [InventoryLine_input]               
                    ) {
                        inventorylines_save(rows: $rows) {
                            id
                        }
                    }
                    `,
                    variables,
                });

            } catch (error) {

            }

        },
        pick_date(evt, prop, line) {
            let find = this.$moment(line[prop], 'YYYY-MM-DD HH:mm').format('DD/MM/YY HH:mm')
            // let find = this.$moment.unix(line[prop]* 0.001).utc(false).format("DD/MM/YY HH:mm")
            let replace = this.$moment(evt.startDate).format('DD/MM/YY HH:mm')
            line.remark = line.remark.split(find).join(replace)
            line[prop] = this.$moment(evt.startDate).format('YYYY-MM-DD HH:mm')
        },
        disabled_suppliertype(line) {
            let result = true
            switch (line.blac) {
                case "MKAMEX":
                case "MWBAAMEX":
                case "NWBAAMEX":
                case "WBAMEX":
                case "BCARDCONF":
                case "BCARDTP":
                case "SVPCONF":
                    result = false
                    break;
            }
            return result
        },
        async saveit() {
            console.log('saveit')

            let tags = JSON.parse(this.item.tags);
            if (this.mifields.length > 0) {
                for (var k = 0; k < this.mifields.length; k++) {
                    tags[this.mifields[k].key] = this.mifields[k].value;
                }
            }
            let requirements = await this.mifields_requirement();
            if (requirements.length > 0) {
                this.message_saveit =
                    "<span class='text-danger'>" +
                    requirements.slice(0, -1) +
                    " required field(s). </span>";
                this.busy = false;
                return;
            } else {
                this.message_saveit = "";
            }

            let rows = []
            for (var i = 0; i < this.lines.length; i++) {
                let row = {
                    id: this.lines[i].id
                }

                // if (this.value.notes || this.value.notes == "") {
                //     row.notes = this.value.notes
                // }
                if (this.value.yourref || this.value.yourref == "") {
                    row.yourref = this.value.yourref
                }

                if (this.lines[i].eventcode || this.lines[i].eventcode == "") {
                    row.eventcode = this.lines[i].eventcode
                }
                if (this.lines[i].slac || this.lines[i].slac == "") {
                    row.slac = this.lines[i].slac
                }

                if (this.lines[i].cost || this.lines[i].cost == "") {
                    row.cost = this.lines[i].cost
                }
                if (this.lines[i].vatr || this.lines[i].vatr == "") {
                    row.vatr = this.lines[i].vatr
                }
                if (this.lines[i].vat || this.lines[i].vat == "") {
                    row.vat = this.lines[i].vat
                }
                if (this.lines[i].sale || this.lines[i].sale == "") {
                    row.sale = this.lines[i].sale
                }
                if (this.lines[i].agent || this.lines[i].agent == "") {
                    row.agent = this.lines[i].agent
                    if (this.lines[i].agent) {
                        this.lines[i].claimed = true
                    }
                }

                if (this.lines[i].passenger || this.lines[i].passenger == "") {
                    row.surname = this.lines[i].passenger.toUpperCase()
                }
                if (this.lines[i].routing || this.lines[i].routing == "") {
                    row.routing = this.lines[i].routing.toUpperCase()
                }
                if (this.lines[i].remark || this.lines[i].remark == "") {
                    row.remark = this.lines[i].remark.toUpperCase()
                }
                if (this.lines[i].start_at || this.lines[i].start_at == "") {
                    row.start_at = this.lines[i].start_at
                }
                if (this.lines[i].end_at || this.lines[i].end_at == "") {
                    row.end_at = this.lines[i].end_at
                }
                if (this.lines[i].type || this.lines[i].type == "") {
                    row.type = this.lines[i].type
                }

                if (tags) {
                    this.item.tags = JSON.stringify(tags);
                    row.tags = this.item.tags;
                }
                rows.push(row)
            }


            let variables = {
                rows
            };
            console.log("variables", variables);

            try {
                const response = await this.$apollo.mutate({
                    mutation: gql`
                    mutation inventorylines_save(
                        $rows: [InventoryLine_input]               
                    ) {
                        inventorylines_save(rows: $rows) {
                            id
                        }
                    }
                    `,
                    variables,
                });
                // const response = await this.$apollo.mutate({
                //     mutation: gql`
                //     mutation bookingforms_save(
                //         $rows: [Bookingform_input]               
                //     ) {
                //         bookingforms_save(rows: $rows) {
                //             id
                //         }
                //     }
                //     `,
                //     variables,
                // });

                this.message_saveit = "<span class='text-primary'>Saved it.</span>";

            } catch (error) {
                this.message_saveit = "<span class='text-danger'>" + error.message + "</span>";
            }

        },

        // async saveit() {

        //     let rows = []
        //     for (var i = 0; i < this.lines.length; i++) {
        //         let row = {
        //             id: this.lines[i].referenceno
        //         }
        //         if (this.value.slac || this.value.slac == "") {
        //             row.slac = this.value.slac
        //         }
        //         if (this.value.eventcode || this.value.eventcode == "") {
        //             row.event = this.value.eventcode
        //         }
        //         if (this.value.yourref || this.value.yourref == "") {
        //             row.yourref = this.value.yourref
        //         }
        //         rows.push(row)
        //     }


        //     let variables = {
        //         rows
        //     };

        //     try {
        //         const response = await this.$apollo.mutate({
        //             mutation: gql`
        //           mutation savebookingforms(
        //             $rows: [Bookingform_input]             
        //           ) {
        //             savebookingforms(rows: $rows) {
        //               id
        //             }
        //           }
        //         `,
        //             variables,
        //         });

        //         this.message_saveit = "<span class='text-primary'>Saved it.</span>";

        //     } catch (error) {
        //         this.message_saveit = "<span class='text-danger'>" + error.message + "</span>";
        //     }

        // },
        async renderit() {

            console.log('renderit')
            this.busy = true
            this.draft = true

            let quote = { ... this.value }
            quote.lines = this.lines //.filter(o => o.cost != 'N/A')
            quote.tags = this.item.tags;

            let variables = {
                data: JSON.stringify(quote),
                prefix: this.prefix,
                creditno: this.creditno,
                ticketno: this.ticketno,
                routing: this.routing,
                confermano: this.confermano.length > 0 ? this.confermano.join(",") : null,
                perline: this.perline,
                apply: false
            };
            try {
                const response = await this.$apollo.query({
                    query: gql`
                    query ihold_draftinvoice(
                      $data: String
                      $prefix: String,
                      $creditno: String
                      $ticketno: String
                      $routing: String
                      $confermano: String
                      $perline: Boolean
                      $apply: Boolean
                  ) {
                    ihold_draftinvoice(
                        data: $data
                        prefix: $prefix
                        creditno: $creditno
                       ticketno: $ticketno
                       routing: $routing
                        confermano: $confermano
                        perline: $perline
                        apply: $apply
                      ) {
                        id
                        ref
                        refcredit
                        to
                        address
                        dateref
                        slac
                        agent
                        yourref
                        booker
                        eventname
                        vatregion
                        terms
                        credit
                        tags
                        data
                        saleexvat
                        salevat
                        saletotal
                         mifields {
                            label
                            value
                        }
                        document {
                          fields {
                            key
                            label
                            class
                          }
                          items
                        }
                        message
                        level
                      }
                  }
                  `,
                    variables,
                    fetchPolicy: "no-cache",
                });

                this.items = response.data.ihold_draftinvoice;
                let sset = this.items
                this.ss = sset

                this.item = { ref: "" }
                if (this.ss.length > 0) {

                    this.item = this.ss[0];
                    if (this.item.salevat == 0) { this.item.salevat = "" }

                    this.SL = []

                    if (this.item.data) {
                        this.data = JSON.parse(this.item.data);
                        this.SL.push({ ...this.data.SL[0] });
                        delete this.SL[0].items;
                    }
                }

            } catch (error) {
                console.log(error);
            }
            this.draft = false
            this.busy = false
        },

        async postit() {
            console.log('postit')

            this.saveit();

            let requirements = await this.mifields_requirement();
            if (requirements.length > 0) {
                this.busy = false;
                return;
            }

            this.busy = true;

            let quote = { ... this.value }
            quote.lines = this.lines // .segments.filter(o => o.fare != 'N/A')
            quote.tags = this.item.tags;

            let variables = {
                data: JSON.stringify(quote),
                prefix: this.prefix,
                creditno: this.creditno,
                ticketno: this.ticketno,
                routing: this.routing,
                confermano: this.confermano.length > 0 ? this.confermano.join(",") : null,
                perline: this.perline,
                apply: true
            };
            console.log("variables", variables);

            try {
                const response = await this.$apollo.query({
                    query: gql`
                    query ihold_draftinvoice(
                      $data: String
                      $prefix: String
                      $creditno: String
                      $ticketno: String
                      $routing: String
                      $confermano: String
                      $perline: Boolean
                      $apply: Boolean
                  ) {
                    ihold_draftinvoice(
                        data: $data
                        prefix: $prefix
                        creditno: $creditno
                        ticketno: $ticketno
                        routing: $routing
                        confermano: $confermano
                        perline: $perline
                        apply: $apply
                      ) {
                        id
                        ref
                        refcredit
                        to
                        address
                        dateref
                        slac
                        agent
                        yourref
                        booker
                        eventname
                        vatregion
                        terms
                        credit
                        data
                        saleexvat
                        salevat
                        saletotal
                         mifields {
                                label
                                value
                            }
                        document {
                          fields {
                            key
                            label
                            class
                          }
                          items
                        }
                        message
                        level
                      }
                  }
                  `,
                    variables,
                    fetchPolicy: "no-cache",
                });

                this.items = response.data.ihold_draftinvoice;
                let sset = this.items
                this.ss = sset

                this.item = { ref: "" }
                if (this.ss.length > 0) {

                    this.item = this.ss[0];
                    if (this.item.salevat == 0) { this.item.salevat = "" }

                    this.SL = []

                    if (this.item.data) {
                        this.data = JSON.parse(this.item.data);
                        this.SL.push({ ...this.data.SL[0] });
                        delete this.SL[0].items;
                    }
                }

            } catch (error) {
                console.log(error);
            }
            this.$emit("postit");

            this.busy = false;
        },
        async load_bookingform(id) {
            if (!id) {
                id = this.refno_options[0]
            }
            console.log(id)
            let variables = {
                referenceno: id,
                mssql: true
            };
            console.log("variables", variables);
            try {
                const response = await this.$apollo.query({
                    query: gql`
                        query bookingforms($mssql: Boolean $referenceno: String) {
                        bookingforms(mssql: $mssql, referenceno: $referenceno) {
                            id
                            payby
                            reason
                            date
                            datetravel
                            blac
                            value
                            deploymentid
                            currency
                            country
                            comments
                            event
                            slac
                            charge
                            invoiceno
                            yourref
                            agent
                            status
                            created_at
                            created_by
                            updated_at
                            updated_by
                        }
                        }
                    `,
                    variables,
                });

                if (response.data.bookingforms.length > 0) {
                    this.notes = response.data.bookingforms[0].comments;
                }

            } catch (error) {
                console.log(error);
            }

        },

        async load_agents() {

            let variables = {
                status: "0",
                rolename: "user,admin",
                department: "F1,EVENTS",
                orderby: [["[firstname]", "asc"]]
            };
            try {
                const response = await this.$apollo.query({
                    query: gql`
            query setup_users($status:String, $rolename:String, $department: String, $orderby: [[String]]) {
                setup_users(status: $status, rolename:$rolename, department: $department, orderby: $orderby) {
                    id: initials
                    label: labelagent
                }
            }
        `,
                    variables,
                });

                this.options_agent = response.data.setup_users

            } catch (error) {
                console.log(error);
            }
        }
    }
};
</script>

<style></style>